export class ApplicationStatuses {
  displayOrder: number;
  id: string;
  name: string;
}
